import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  label: string;
  disabled?: boolean;
  onChange?: (files: FileList) => void;
}

export function FileInput({ label, disabled, onChange }: Props) {
  const { t } = useTranslation();
  const id = crypto.randomUUID();
  const ref = useRef<HTMLInputElement | null>(null);

  return (
    <span className="grid">
      <label htmlFor={id} className="group-focus-within:text-primary-300 text-label">
        {t(label)}
      </label>
      <div
        className="group grid place-items-center w-full min-h-[160px] border border-neutral-900 border-opacity-30 border-dashed rounded p-6 hover:border-opacity-100 bg-transparent"
        onDragEnter={(e) => e.preventDefault()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onChange?.(e.dataTransfer.files);
        }}
      >
        <input
          type="file"
          className="hidden"
          multiple
          value={[]}
          id={id}
          ref={ref}
          disabled={disabled}
          accept="image/*"
          onChange={(e) => onChange?.(e.target.files!)}
        />
        <i className="ri-upload-cloud-2-line ri-7x leading-tight opacity-50 group-hover:opacity-100" />
        <button type="button" className="primary-fill" onClick={() => ref.current?.click()}>
          {t('fileUpload.browse')}
        </button>
      </div>
    </span>
  );
}
